import React, { useState, useEffect } from 'react';
import api from '../api/client';
import './DemandDetailsPopup.css';

const DemandDetailsPopup = ({ materialType, sku, year, month, forecastId, onClose }) => {
    const [data, setData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                let url;
                if (materialType === 'smallbags') {
                    url = `/api/smallbags_details?sbsku=${sku}&year=${year}&month=${month}&forecast_id=${forecastId}`;
                } else if (materialType === 'seeds') {
                    url = `/api/seeds_details?seedsid=${sku}&year=${year}&month=${month}&forecast_id=${forecastId}`;
                } else if (materialType === 'addons') {
                    url = `/api/addons_details?addonType=${sku}&year=${year}&month=${month}&forecast_id=${forecastId}`;
                }
                const response = await api.get(url);
                console.log(`API Response for ${materialType}:`, response.data); // Отладочный вывод
                setData(response.data);
            } catch (error) {
                console.error('Error fetching details:', error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [materialType, sku, year, month, forecastId]);

    const filteredData = data.filter(item => {
        const search = searchTerm.toLowerCase();
        const sku = (item.sku || item.setsku || '').toLowerCase();
        const brandID = (item.brandID || '').toLowerCase();
        const name = (item.name || item.setName || '').toLowerCase();
        return sku.includes(search) || brandID.includes(search) || name.includes(search);
    });

    return (
        <div className="popup-overlay">
            <div className="popup-container">
                <div className="popup-header">
                    <h2>
                        {materialType === 'smallbags' ? 'Small Bags' : 
                         materialType === 'seeds' ? 'Seeds' : 
                         'Addons'} Details
                    </h2>
                    <button className="close-btn" onClick={onClose}>×</button>
                </div>
                <input
                    type="text"
                    placeholder="Search by SKU, Brand, or Name"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                />
                <div className="table-container">
                    {isLoading ? (
                        <p>Loading...</p>
                    ) : filteredData.length === 0 ? (
                        <p>No data available</p>
                    ) : (
                        <table className="details-table">
                            <thead>
                                <tr>
                                    <th>Brand</th>
                                    {materialType === 'seeds' ? (
                                        <>
                                            <th>Type</th>
                                            <th>SKU</th>
                                            <th>Name</th>
                                            <th>Plan To Produce (lb)</th>
                                        </>
                                    ) : (
                                        <>
                                            <th>Set SKU</th>
                                            <th>Set Name</th>
                                            <th>Plan To Produce</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.brandID || '-'}</td>
                                        {materialType === 'seeds' ? (
                                            <>
                                                <td>{item.type || '-'}</td>
                                                <td>{item.sku || '-'}</td>
                                                <td>{item.name || '-'}</td>
                                                <td>{Number(item.to_produce_lb || 0).toFixed(2)}</td>
                                            </>
                                        ) : (
                                            <>
                                                <td>{(item.sku || item.setsku) || '-'}</td>
                                                <td>{(item.name || item.setName) || '-'}</td>
                                                <td>{Number(item.to_produce || 0)}</td>
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DemandDetailsPopup;